// config.js
const currentURL = window.location.origin;

export const apiURL =
  currentURL.includes("localhost")
    ? "http://localhost:5000/api/"
    : "https://budget-boss-backend.vercel.app/api/";

// OPTX is a separate deployment, so quotation branding never depends on document creators.
export const COMPANY_PREFIX = "OPTX";
export const COMPANY_FINANCE_NAME = "OPTX FINANCE";
export const COMPANY_LOGO_URL = "https://i.imgur.com/vHJYGdx.png";
